import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbbeb954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-md" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "my-sm" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "data-container g-sm" }
const _hoisted_6 = { class: "flex-centered g-sm" }
const _hoisted_7 = { class: "aff-label" }
const _hoisted_8 = { class: "aff-value" }
const _hoisted_9 = { class: "flex-centered g-sm" }
const _hoisted_10 = { class: "aff-label" }
const _hoisted_11 = { class: "aff-value" }
const _hoisted_12 = { class: "flex-centered g-sm" }
const _hoisted_13 = { class: "aff-label" }
const _hoisted_14 = { class: "aff-value" }
const _hoisted_15 = { class: "flex-centered g-sm" }
const _hoisted_16 = { class: "aff-label" }
const _hoisted_17 = { class: "aff-value" }
const _hoisted_18 = { class: "logo-container" }
const _hoisted_19 = ["src"]

import type { PropType } from "vue";
import type { AffiliatesPageItems } from "@/types/pages";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliatesPage',
  props: {
  affiliates: {
    type: Array as PropType<AffiliatesPageItems[]>,
    default: () => [
      {
        name: "Numibal",
        logo: require("@/assets/imgs/affiliates/numibal.png"),
      },
      {
        name: "Contacto",
        logo: require("@/assets/imgs/affiliates/contacto.png"),
      },
    ],
  },
  promPtImages: {
    type: Array,
    default: () => [
      require("@/assets/imgs/prom-pt/1.jpg"),
      require("@/assets/imgs/prom-pt/2.jpg"),
      require("@/assets/imgs/prom-pt/3.jpg"),
      require("@/assets/imgs/prom-pt/4.jpg"),
      require("@/assets/imgs/prom-pt/5.jpg"),
      require("@/assets/imgs/prom-pt/6.jpg"),
      require("@/assets/imgs/prom-pt/7.jpg"),
      require("@/assets/imgs/prom-pt/8.jpg"),
      require("@/assets/imgs/prom-pt/10.jpg"),
      require("@/assets/imgs/prom-pt/11.png"),
      require("@/assets/imgs/prom-pt/12.jpg"),
      require("@/assets/imgs/prom-pt/13.jpg"),
    ],
  },
},
  setup(__props) {

const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  const _component_ImgSlider = _resolveComponent("ImgSlider")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("immo_prom_portugal")), 1),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("immo_prom_desc")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ImgSlider, {
          items: __props.promPtImages,
          height: "70vh"
        }, null, 8, ["items"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("belgium_affiliates")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.affiliates, (affiliate) => {
        return (_openBlock(), _createElementBlock("div", {
          key: affiliate.name,
          class: "affiliate-container my-sm"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, {
                icon: "building",
                size: "sm"
              }),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("name")) + ":", 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(affiliate.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, {
                icon: "phone",
                size: "sm"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)("phoneNumber")) + ":", 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(affiliate.phoneNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_font_awesome_icon, {
                icon: "at",
                size: "sm"
              }),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("email")) + ":", 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(affiliate.email), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_font_awesome_icon, {
                icon: "map-location-dot",
                size: "sm"
              }),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("address")) + ":", 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(affiliate.address), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("img", {
              src: affiliate.logo,
              style: {"object-fit":"contain","height":"15rem","max-width":"75%"}
            }, null, 8, _hoisted_19)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})